import React, { Component } from 'react'
import { Form, Divider, InputNumber, Button, Spin } from 'antd'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next';
import adminI18n from '../../../admin/i18n/adminI18n';

@inject("stockStore")
@observer
class UpdateStock extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
    }

    stockChange = (value) => this.props.stockStore.setStock(value)

    cancelUpdateStockButtonClicked = () => {
        this.props.stockStore.setShowUpdateStockModal(false)
    }

    updateStockButtonClicked = () => {
        this.props.stockStore.updateStock()
    }

    render() {
        const { t } = this.props;
        const {
            taskName,
            category,
            minimumStock,
            currentStock,
            updateLoading
        } = this.props.stockStore;

        return (
            <Spin spinning={updateLoading}>
                <Form layout="vertical">
                    <Form.Item label={t('Category')}>
                        <b>{category}</b>
                    </Form.Item>
                    <Form.Item label={t('Task Name')}>
                        <b>{taskName}</b>
                    </Form.Item>
                    <Form.Item label={t('Minimum Stock')}>
                        <b>{minimumStock}</b>
                    </Form.Item>

                    <Divider>{t('Adjust Your Stock')}</Divider>
                    <Form.Item label={t('Adjust Stock')}>
                        <InputNumber min={minimumStock} value={currentStock} onChange={this.stockChange} />
                    </Form.Item>

                    <Form.Item>
                        <Button onClick={this.updateStockButtonClicked} type="primary" style={{ marginRight: 10 }}>{t('Update')}</Button>
                        <Button onClick={this.cancelUpdateStockButtonClicked}>{t('Cancel')}</Button>
                    </Form.Item>
                </Form>
            </Spin>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(UpdateStock);